const ASSOCIATETypes = {
    ASSOCIATE_ACTION_START:"ASSOCIATE_ACTION_START",
    ASSOCIATE_FETCH_DATA:"ASSOCIATE_FETCH_DATA",
    ASSOCIATE_FETCH_DATA_FAILED:"ASSOCIATE_FETCH_DATA_FAILED",
    ASSOCIATE_ADD_DATA:"ASSOCIATE_ADD_DATA",
}

const Initial_state = {
    loading: false,
    error_message: null,
    isSuccess: false,
    response: [],
    set_payload: ""
}

const ASSOCIATEReducer = (state=Initial_state, action) => {
    switch(action.type){
        case ASSOCIATETypes.ASSOCIATE_ACTION_START:
            return {
                ...state,
                loading: true,
            }

        case ASSOCIATETypes.ASSOCIATE_FETCH_DATA: 
            return {
                ...state,
                loading: false,
                isSuccess: true,
                response: action.payload.data,
                set_payload: action.payload.set_payload
            }

        case ASSOCIATETypes.ASSOCIATE_FETCH_DATA_FAILED: 
            return {
                ...state,
                loading: false,
                isSuccess: false,
                error: action.payload
            }

        default:
            return state;
    }
};

export default ASSOCIATEReducer;